export default "__VITE_ASSET__2c9d727a__"